import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

export default firebase
